import { render, staticRenderFns } from "./CharacterStats.vue?vue&type=template&id=6f522a02&"
import script from "./CharacterStats.vue?vue&type=script&lang=js&"
export * from "./CharacterStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports